// import React, { useState, useEffect } from 'react';
// import { ArrowLeft, Eye, ArrowRight, Hand, Heart, MapPin, Calendar, Camera, Star, Globe } from 'lucide-react';

// const PS5PromoUI = ({ isInPreview = false, onExpand }) => {
//   const [isAnimating, setIsAnimating] = useState(false);

//   const handleTap = () => {
//     setIsAnimating(true);
//     setTimeout(() => setIsAnimating(false), 600);
//     if (onExpand) {
//       setTimeout(() => onExpand(), 300);
//     }
//   };

//   return (
//     <div
//     className={`w-full ${
//       isInPreview ? "h-full" : "h-96"
//     } bg-gradient-to-b from-blue-950 via-blue-900 to-indigo-950 flex items-center justify-center ${
//       isInPreview ? "p-2 sm:p-4" : "p-8"
//     } relative overflow-hidden`}
//   >
//     {/* Animated stars background */}
//     <div className="absolute inset-0">
//       {[...Array(30)].map((_, i) => (
//         <div
//           key={i}
//           className="absolute w-1 h-1 bg-white rounded-full opacity-60 animate-pulse"
//           style={{
//             left: `${Math.random() * 100}%`,
//             top: `${Math.random() * 100}%`,
//             animationDelay: `${Math.random() * 2}s`,
//             animationDuration: `${2 + Math.random() * 2}s`,
//           }}
//         />
//       ))}
//     </div>

//     <div className="text-center w-full relative z-10">
//       {/* PS5 Image */}
//       <div
//         className={`relative mb-2 cursor-pointer ${
//           isAnimating ? "scale-110" : "hover:scale-105"
//         } transition-all duration-300`}
//         onClick={handleTap}
//       >
// <img
//   src="/assets/gift.png" // Replace with your PS5 image path
//   alt="PlayStation 5"
//   className={`mx-auto ${isInPreview ? "w-24 sm:w-32" : "w-48"}`}
// />

//         {/* Tap indicator - only show if not in small preview */}
//         {!isInPreview && (
//           <div className="absolute -top-8 -right-8 bg-gray-800 text-white px-3 py-2 rounded-full text-sm font-medium shadow-lg border border-gray-600">
//             Tap
//             <div className="absolute bottom-0 left-8 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
//           </div>
//         )}
//       </div>

//       {/* PlayStation 5 Title */}
//       <h1
//         className={`text-white font-bold mb-2 tracking-wide ${
//           isInPreview ? "text-lg sm:text-2xl" : "text-4xl mb-6"
//         }`}
//       >
//         Umlock the Power of PlayStation 5
//       </h1>

//       {/* Description Text */}
//       <div
//         className={`text-gray-200 leading-relaxed space-y-1 ${
//           isInPreview ? "text-xs sm:text-sm mb-3" : "text-lg mb-8"
//         }`}
//       >
//         <p>Tap the gift to discover an exclusive offer made for the players.</p>
//       </div>

//       {/* Shop Now Button */}
//       <button
//         className={`bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl active:scale-95 ${
//           isInPreview ? "py-2 px-6 text-xs sm:text-sm" : "py-4 px-8 text-sm"
//         }`}
//       >
//         Discover PS5
//       </button>

//       {/* Subtle glow effect */}
//       <div className="absolute -inset-4 bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-3xl blur-3xl -z-10"></div>
//     </div>
//   </div>

//   );
// };

// const AnimatedGiftBox = ({ isInPreview = false, onGiftOpen }) => {
//   const [isOpened, setIsOpened] = useState(false);
//   const [showHand, setShowHand] = useState(false);
//   const [isOpening, setIsOpening] = useState(false);
//   const [showContent, setShowContent] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowHand(true);
//     }, 2000);
//     return () => clearTimeout(timer);
//   }, []);

//   const handleGiftClick = () => {
//     setIsOpening(true);
//     setTimeout(() => {
//       setShowContent(true);
//     }, 800);
//     setTimeout(() => {
//       setIsOpened(true);
//       if (onGiftOpen) {
//         onGiftOpen();
//       }
//     }, 1500);
//   };

//   const closeAd = () => {
//     setIsOpened(false);
//     setIsOpening(false);
//     setShowContent(false);
//     setShowHand(false);
//   };

//   return (
//     <div className="w-full h-full bg-gradient-to-br from-black via-blue-900 to-blue-950 flex items-center justify-center relative overflow-hidden">
//       {/* Floating particles background */}

//       <div
//   className="absolute inset-0 opacity-60 bg-black "
//   style={{
//     backgroundImage: url('/assets/ps111.png'),
//     backgroundSize: 'cover',
//     backgroundPosition: 'center'
//   }}></div>
//       <div className="absolute inset-0">
//         {[...Array(isInPreview ? 15 : 30)].map((_, i) => (
//           <div
//             key={i}
//             className="absolute w-1 h-1 bg-white rounded-full opacity-30 animate-pulse"
//             style={{
//               left: ${Math.random() * 100}%,
//               top: ${Math.random() * 100}%,
//               animationDelay: ${Math.random() * 3}s,
//               animationDuration: ${2 + Math.random() * 2}s
//             }}
//           />
//         ))}
//       </div>

//       {!isOpened ? (
//         <div className="relative">
//           {/* Gift Box Container */}
//           <div
//             className={`relative cursor-pointer transform transition-all duration-1000 ${
//               showHand ? 'hover:scale-110 hover:rotate-2' : 'animate-bounce'
//             } ${isOpening ? 'animate-pulse scale-125' : ''}`}
//             onClick={handleGiftClick}
//           >
//             {/* Gift Box Shadow */}
//             <div className="absolute top-6 left-2 w-20 h-6 bg-black opacity-20 rounded-full blur-md transform scale-x-150" />

//             {/* PlayStation Gift Box Base */}
//             <div className="relative">
//               {/* Box Body */}
//               <div className={`w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg shadow-2xl border-2 border-blue-700 transform transition-all duration-1000 ${
//                 isOpening ? 'rotate-y-45 scale-110' : 'rotate-y-12'
//               }`}>

//                 {/* Box Lid */}
//                 <div className={`absolute -top-2 -left-1 w-22 h-5 bg-gradient-to-br from-blue-400 to-blue-500 rounded-lg shadow-lg border border-blue-600 transform transition-all duration-1000 ${
//                   isOpening ? 'rotate-45 translate-y-4 translate-x-6 scale-110' : ''
//                 }`}>
//                   <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-2 h-full bg-gradient-to-b from-white to-gray-200 shadow-inner" />
//                 </div>

//                 {/* Vertical Ribbon */}
//                 <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-2 h-full bg-gradient-to-b from-white to-gray-200 shadow-inner" />

//                 {/* Horizontal Ribbon */}
//                 <div className="absolute top-1/2 left-0 transform -translate-y-1/2 w-full h-2 bg-gradient-to-r from-white to-gray-200 shadow-inner" />

//                 {/* PlayStation Logo on Box */}
//                 <div className="absolute top-1 left-1 text-white font-bold text-xs">PS5</div>

//                 {/* Bow */}
//                 <div className={`absolute -top-3 left-1/2 transform -translate-x-1/2 transition-all duration-700 ${
//                   isOpening ? 'scale-150 rotate-180' : ''
//                 }`}>
//                   <div className="relative">
//                     <div className="w-4 h-3 bg-gradient-to-br from-white to-gray-200 rounded-full shadow-lg" />
//                     <div className="absolute -left-2 top-0 w-4 h-3 bg-gradient-to-bl from-white to-gray-200 rounded-full shadow-lg" />
//                     <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1 h-2 bg-gray-300 rounded shadow-inner" />
//                   </div>
//                 </div>

//                 {/* Content Preview - PlayStation 5 emerging */}
//                 {showContent && (
//                   <div className="absolute top-2 left-1/2 transform -translate-x-1/2 animate-bounce">
//                     <div className="w-10 h-12 bg-white rounded-lg shadow-xl transform rotate-12 animate-pulse">
//                       <div className="absolute inset-0.5 bg-gradient-to-br from-gray-100 to-gray-300 rounded-md flex items-center justify-center">
//                         <div className="text-xs font-bold text-gray-600">PS5</div>
//                       </div>
//                       <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-blue-500 rounded-full animate-ping" />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Animated Hand Cursor */}
//           {showHand && !isOpening && (
//             <div className="absolute -right-10 -top-6 animate-bounce">
//               <Hand
//                 size={24}
//                 className="text-white drop-shadow-lg transform rotate-12 animate-pulse"
//               />
//               <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-2 py-1 rounded-full text-xs whitespace-nowrap">
//                 Click!
//               </div>
//             </div>
//           )}

//           {/* Enhanced Sparkle effects */}
//           <div className="absolute -inset-8 pointer-events-none">
//             {[...Array(8)].map((_, i) => (
//               <div
//                 key={i}
//                 className={`absolute w-1 h-1 bg-yellow-300 rounded-full ${
//                   isOpening ? 'animate-ping' : 'animate-pulse'
//                 }`}
//                 style={{
//                   left: ${20 + Math.random() * 60}%,
//                   top: ${20 + Math.random() * 60}%,
//                   animationDelay: ${i * 0.3}s,
//                   animationDuration: isOpening ? '0.5s' : '2s'
//                 }}
//               />
//             ))}
//           </div>

//           {/* Opening burst effect */}
//           {isOpening && (
//             <div className="absolute inset-0 pointer-events-none">
//               {[...Array(12)].map((_, i) => (
//                 <div
//                   key={i}
//                   className="absolute w-0.5 h-0.5 bg-white rounded-full animate-ping"
//                   style={{
//                     left: '50%',
//                     top: '50%',
//                     transform: translate(-50%, -50%) rotate(${i * 30}deg) translateY(-${30 + Math.random() * 30}px),
//                     animationDelay: ${i * 0.1}s,
//                     animationDuration: '1s'
//                   }}
//                 />
//               ))}
//             </div>
//           )}
//         </div>
//       ) : (
//         /* PS5 Ad Content after opening */
//         <div className="w-full h-full bg-black bg-opacity-95 flex items-center justify-center relative">
//           <button
//             onClick={closeAd}
//             className="absolute top-2 right-2 w-6 h-6 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full flex items-center justify-center text-white text-sm font-bold transition-all duration-300 hover:scale-110"
//           >
//             ×
//           </button>

//           <div className="relative p-4 text-center">
//             <div className="flex items-center justify-center mb-3">
//               <div className="text-lg font-bold text-white mr-2">PlayStation</div>
//               <div className="text-2xl font-bold text-blue-400">5</div>
//             </div>

//             <div className="w-16 h-16 mx-auto mb-3 rounded-lg shadow-xl overflow-hidden">
//               <div className="w-full h-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center">
//                 <div className="text-white font-bold text-xs">PS5</div>
//               </div>
//             </div>

//             <div className="text-white text-xs mb-2 font-bold">
//               🎮 EXCLUSIVE DEAL! 🎮
//             </div>
//             <div className="text-white text-xs mb-3">
//               PlayStation 5 Console
//             </div>
//             <button className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold py-2 px-4 rounded-full text-xs hover:scale-105 transition-transform">
//               Shop Now!
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const ImageAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
//   const [showGiftBox, setShowGiftBox] = useState(true);

//   const handleExpand = () => {
//     if (onExpand && !isInPreview) {
//       onExpand();
//     }
//   };

//   const handleGiftOpen = () => {
//     setShowGiftBox(false);
//   };

//   return (
//     <>
//     <div className={w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}}>
//       {!isExpanded ? (
//         <div className="relative h-full">
//           {/* Show gift box initially, then image after opening */}
//           {showGiftBox ? (
//             <AnimatedGiftBox
//               isInPreview={isInPreview}
//               onGiftOpen={handleGiftOpen}
//             />
//           ) : (
//             <div
//               className={`relative cursor-pointer transform transition-all duration-300 ${
//                 !isInPreview ? 'hover:scale-105' : ''
//               } w-full h-full`}
//               onClick={handleExpand}
//             >
//               {/* Image Container with PS5 theme */}
//               <div className="relative w-full h-full bg-gradient-to-br from-blue-900 to-black overflow-hidden">
//                 <img
//                   src="/assets/ps.avif"
//                   alt="PlayStation 5 Console"
//                   className="w-full h-full object-cover"
//                 />

//                 {/* PS5 Themed Overlay */}
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none" />

//                 {/* AD Label with PS5 styling */}
//                 <div className="absolute top-2 left-2 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-bold border border-blue-400">
//                   PS5 AD
//                 </div>

//                 {/* PS5 Brand Overlay */}
//                 <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/80 to-transparent p-4">
//                   <div className="text-white">
//                     <div className="flex items-center mb-2">
//                       <div className="text-sm font-bold mr-2">PlayStation</div>
//                       <div className="text-lg font-bold text-blue-400">5</div>
//                     </div>
//                     <p className="text-xs text-white/90 mb-3">Experience gaming like never before</p>
//                     <button className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 rounded-full text-xs font-bold hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-105">
//                       Discover PS5
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       ) : (
//         /* Expanded Image Experience - Full Screen */
//         <div className="w-full h-full flex items-center justify-center relative bg-black">
//           <button
//             onClick={onClose}
//             className="absolute top-4 right-4 w-12 h-12 bg-blue-600/20 hover:bg-blue-600/40 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10 border border-blue-400/30"
//           >
//             ×
//           </button>

//           <div className="relative w-full h-full max-w-6xl flex items-center justify-center">
//             <img
//               src="/assets/ps.avif"
//               alt="PlayStation 5 Console"
//               className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
//             />

//             {/* PS5 Brand overlay for expanded view */}
//             <div className="absolute bottom-6 left-6 bg-black/80 backdrop-blur-md rounded-xl p-6 text-white border border-blue-500/30">
//               <div className="flex items-center mb-3">
//                 <div className="text-2xl font-bold mr-3">PlayStation</div>
//                 <div className="text-3xl font-bold text-blue-400">5</div>
//               </div>
//               <p className="text-sm opacity-90 mb-4 max-w-xs">The ultimate gaming experience awaits. Discover incredible games and immersive worlds.</p>
//               <button className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-8 py-3 rounded-full font-bold hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-105">
//                 Shop PlayStation 5
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes twinkle {
//           0%, 100% { opacity: 0; transform: scale(0); }
//           50% { opacity: 1; transform: scale(1); }
//         }
//         .animate-twinkle {
//           animation: twinkle 2s infinite;
//         }
//       `}</style>
//     </div>

//     </>
//   );
// };

// function GiftBoxAdMockup() {
//   const [isMobile, setIsMobile] = useState(true);
//   const [isExpanded, setIsExpanded] = useState(false);

//   return (
//     <>
//       <div className="min-h-screen bg-gray-50 mt-10">
//         <div className="container mx-auto px-4 py-8 lg:py-12">
//           <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
//             {/* Left column - Content */}
//             <div className="flex-1 lg:max-w-lg">
//               {/* Header */}
//               <header className="animate-slide-up">
//                 <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
//                   <div className="flex flex-wrap items-center gap-3 mb-3">
//                     <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
//                       Tap to Reveal. Power Unleashed.
//                     </h1>
//                     <span className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 rounded-full text-sm font-bold">
//                       Tap to Reveal
//                     </span>
//                   </div>
//                 </div>
//               </header>

//               {/* Content Section */}
//               <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
//                 {/* Make it yours section */}
//                 <div className="mb-8">
//                   <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
//                     EXPERIENCE THE POWER OF PS5
//                   </h2>
//                   <p className="text-gray-900 leading-relaxed mb-6 max-w-md">
//                     This interactive ad lets users tap to unlock the next-gen thrill of PlayStation 5. With each tap, the gift box opens to reveal powerful visuals and features—creating a sense of excitement around the launch. Just plug in your images and branding to deliver an immersive experience built for gamers and fans alike.
//                   </p>

//                   {/* CTA Button */}
//                   <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
//                     <span>Start with this Template</span>
//                     <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Right column - Template Preview */}
//             <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
//               {/* Preview toggle */}
//               <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
//                 <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-blue-500/30">
//                   <div className="flex items-center space-x-4">
//                     <div className="flex items-center space-x-3">
//                       <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-400' : 'text-gray-400'}`}>
//                         Mobile
//                       </span>
//                       <button
//                         onClick={() => setIsMobile(!isMobile)}
//                         className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
//                       >
//                         <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
//                       </button>
//                       <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                         Desktop
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
//                 {/* Mobile Mockup */}
//                 {isMobile && (
//                   <div className="mx-auto max-w-xs">
//                     {/* iPhone mockup with PS5 theme */}
//                     <div className="relative rounded-[2.5rem] p-2 shadow-2xl bg-gradient-to-br from-gray-800 to-gray-900">
//                       {/* Status bar area */}
//                       <div className="bg-black rounded-[2rem] overflow-hidden border border-gray-700">
//                         {/* Status bar */}
//                         <div className="bg-black px-6 py-2 flex justify-between items-center text-white text-sm font-medium">
//                           <span>9:41</span>
//                           <div className="flex items-center space-x-1">
//                             <div className="flex space-x-1">
//                               <div className="w-1 h-1 bg-white rounded-full"></div>
//                               <div className="w-1 h-1 bg-white rounded-full"></div>
//                               <div className="w-1 h-1 bg-white rounded-full"></div>
//                               <div className="w-1 h-1 bg-white rounded-full"></div>
//                             </div>
//                             <div className="w-6 h-3 border border-white rounded-sm relative">
//                               <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Browser bar */}
//                         <div className="bg-gray-900 px-4 py-3 flex items-center space-x-3">
//                           <div className="flex-1 bg-gray-800 rounded-lg px-3 py-2 text-sm text-gray-400 flex items-center justify-center border border-gray-700">
//                             playstation.com
//                           </div>
//                         </div>

//                         {/* Content area */}
//                         <div className="p-2 bg-gray-900 h-[400px] overflow-y-auto hide-scrollbar">
//                           <div className="space-y-2 mb-3">
//                             <div className="h-2 bg-gray-700 rounded w-full"></div>
//                             <div className="h-2 bg-gray-700 rounded w-3/4"></div>
//                             <div className="h-2 bg-gray-700 rounded w-5/6"></div>
//                           </div>

//                           {/* PS5 Image Ad - Properly sized for mobile */}
//                           <div className="mb-4">
//                             <div className="h-80 rounded-lg overflow-hidden border border-blue-500/30">
//                               <PS5PromoUI isInPreview={true} onExpand={() => setIsExpanded(true)} />
//                             </div>
//                           </div>

//                           {/* Additional content */}
//                           <div className="space-y-2">
//                             <div className="h-2 bg-gray-700 rounded w-full"></div>
//                             <div className="h-2 bg-gray-700 rounded w-5/6"></div>
//                             <div className="h-2 bg-gray-700 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-2 mt-2">
//                             <div className="h-2 bg-gray-700 rounded w-full"></div>
//                             <div className="h-2 bg-gray-700 rounded w-5/6"></div>
//                             <div className="h-2 bg-gray-700 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-2 mt-2">
//                             <div className="h-2 bg-gray-700 rounded w-full"></div>
//                             <div className="h-2 bg-gray-700 rounded w-5/6"></div>
//                             <div className="h-2 bg-gray-700 rounded w-4/6"></div>
//                           </div>
//                           <div className="space-y-2 mt-2">
//                             <div className="h-2 bg-gray-700 rounded w-full"></div>
//                             <div className="h-2 bg-gray-700 rounded w-5/6"></div>
//                             <div className="h-2 bg-gray-700 rounded w-4/6"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}

//                 {/* Desktop Mockup */}
//                 {!isMobile && (
//                   <div className="w-full max-w-2xl mx-auto">
//                     {/* Desktop Screen Frame */}
//                     <div className="bg-gray-800 rounded-xl p-3 shadow-2xl">
//                       {/* Screen */}
//                       <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700" style={{ aspectRatio: '16/10' }}>
//                         {/* macOS-style window header */}
//                         <div className="bg-gray-800 px-4 py-2 flex items-center border-b border-gray-700">
//                           <div className="flex space-x-2">
//                             <div className="w-3 h-3 bg-red-400 rounded-full"></div>
//                             <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
//                             <div className="w-3 h-3 bg-green-400 rounded-full"></div>
//                           </div>
//                           <div className="flex-1 mx-6">
//                             <div className="bg-gray-700 rounded-md px-3 py-1 text-sm text-gray-400 border border-gray-600 shadow-sm max-w-md">
//                               🔒 playstation.com
//                             </div>
//                           </div>
//                         </div>

//                         {/* Browser content area */}
//                         <div className="p-4 bg-gray-900 h-[500px] overflow-y-auto hide-scrollbar">
//                           {/* Page header */}
//                           <div className="mb-4">
//                             <div className="h-4 bg-gray-700 rounded w-1/3 mb-2"></div>
//                             <div className="h-3 bg-gray-700 rounded w-1/2"></div>
//                           </div>

//                           {/* PS5 Image Ad positioned in content */}
//                           <div className="flex justify-center mb-6">
//                             <div className="w-80 h-64 overflow-hidden rounded-lg border border-blue-500/30">
//                               <PS5PromoUI isInPreview={false} onExpand={() => setIsExpanded(true)} />
//                             </div>
//                           </div>

//                           {/* Additional content placeholders */}
//                           <div className="grid grid-cols-2 gap-6 mb-6">
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-700 rounded w-full"></div>
//                               <div className="h-3 bg-gray-700 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-700 rounded w-4/6"></div>
//                             </div>
//                             <div className="space-y-3">
//                               <div className="h-4 bg-gray-700 rounded w-full"></div>
//                               <div className="h-3 bg-gray-700 rounded w-5/6"></div>
//                               <div className="h-3 bg-gray-700 rounded w-4/6"></div>
//                             </div>
//                           </div>

//                           {/* Sidebar placeholders */}
//                           <div className="grid grid-cols-3 gap-4">
//                             <div className="h-24 bg-gray-700 rounded"></div>
//                             <div className="h-24 bg-gray-700 rounded"></div>
//                             <div className="h-24 bg-gray-700 rounded"></div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Monitor stand */}
//                     <div className="flex justify-center">
//                       <div className="w-20 h-4 bg-gray-700 rounded-b-lg"></div>
//                     </div>
//                     <div className="flex justify-center">
//                       <div className="w-32 h-2 bg-gray-600 rounded-full"></div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Expanded Image Overlay */}
//         {/* {isExpanded && (
//           <ExpandedPS5Screen onClose={() => setIsExpanded(false)} />
//         )}ed && (
//           <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center p-4" onClick={() => setIsExpanded(false)}>
//             <div className="max-w-4xl w-full max-h-full bg-black rounded-lg overflow-hidden">
//               <PS5PromoUI isInPreview={false} />
//             </div>
//           </div>
//         )} */}

//         <style jsx>{`
//           @keyframes slide-up {
//             from {
//               opacity: 0;
//               transform: translateY(20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }

//           @keyframes fade-in {
//             from { opacity: 0; }
//             to { opacity: 1; }
//           }

//           .animate-slide-up {
//             animation: slide-up 0.6s ease-out forwards;
//           }

//           .animate-fade-in {
//             animation: fade-in 0.6s ease-out forwards;
//           }

//           .hide-scrollbar {
//             -ms-overflow-style: none;
//             scrollbar-width: none;
//           }

//           .hide-scrollbar::-webkit-scrollbar {
//             display: none;
//           }
//         `}</style>
//       </div>

//       <div className="max-w-7xl mx-auto px-4 py-10">
//         <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>

//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//           {/* Card 1 */}
//           <div className="block group relative rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl cursor-pointer">
//             <div className="w-full h-60 bg-gradient-to-br from-orange-400 to-red-500 flex items-center justify-center">
//               <div className="text-white font-bold text-xl">Scratch Card</div>
//             </div>
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Scratch TO Win</h2>
//             </div>
//           </div>

//           {/* Card 2 */}
//           <div className="block group relative rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl cursor-pointer">
//             <div className="w-full h-60 bg-gradient-to-br from-purple-400 to-pink-500 flex items-center justify-center">
//               <div className="text-white font-bold text-xl">Swipe Card</div>
//             </div>
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Swipe to Reveal</h2>
//             </div>
//           </div>

//           {/* Card 3 */}
//           <div className="block group relative rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl cursor-pointer">
//             <div className="w-full h-60 bg-gradient-to-br from-blue-400 to-cyan-500 flex items-center justify-center">
//               <div className="text-white font-bold text-xl">Tap Card</div>
//             </div>
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Tap to Reveal</h2>
//             </div>
//           </div>

//           {/* Card 4 */}
//           <div className="block group relative rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl cursor-pointer">
//             <div className="w-full h-60 bg-gradient-to-br from-green-400 to-blue-500 flex items-center justify-center">
//               <div className="text-white font-bold text-xl">Travel Card</div>
//             </div>
//             <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <h2 className="text-lg font-semibold">Dubai Travel</h2>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default GiftBoxAdMockup;

import React, { useState, useEffect } from "react";
import {
  ArrowLeft,
  Eye,
  ArrowRight,
  Hand,
  Heart,
  MapPin,
  Calendar,
  Camera,
  Star,
  Globe,
  X,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
const PS5PromoUI = ({ isInPreview = false, onExpand }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleTap = () => {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 600);
    if (onExpand) {
      setTimeout(() => onExpand(), 300);
    }
  };

  return (
    <div
      className={`w-full ${
        isInPreview ? "h-full" : "h-96"
      } bg-gradient-to-b from-[#061c3c] via-[#0c2b5a] to-[#123a79]  flex items-center justify-center ${
        isInPreview ? "p-2 sm:p-4" : "p-8"
      } relative overflow-hidden cursor-pointer`}
      onClick={handleTap}
    >
      {/* Animated stars background */}
      <div className="absolute inset-0">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full opacity-60 animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${2 + Math.random() * 2}s`,
            }}
          />
        ))}
      </div>

      <div className="text-center w-full relative z-10">
        {/* PS5 Image */}
        <div
          className={`relative mb-2 ${
            isAnimating ? "scale-110" : "hover:scale-105"
          } transition-all duration-300`}
        >
          <img
            src="/assets/gift.png" // Replace with your PS5 image path
            alt="PlayStation 5"
            className={`mx-auto ${isInPreview ? "w-24 sm:w-32" : "w-32"}`}
          />

          {/* Tap indicator - only show if not in small preview */}
          {/* {!isInPreview && (
          <div className="absolute -top-8 -right-8 bg-gray-800 text-white px-3 py-2 rounded-full text-sm font-medium shadow-lg border border-gray-600">
            Tap
            <div className="absolute bottom-0 left-8 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
          </div>
        )} */}
        </div>

        {/* PlayStation 5 Title */}
        <h1
          className={`text-white font-bold mb-2 tracking-wide ${
            isInPreview ? "text-lg sm:text-2xl" : "text-xl mb-2"
          }`}
        >
          Unlock the Power of PlayStation5
        </h1>

        {/* Description Text */}
        <div
          className={`text-gray-200 leading-relaxed space-y-1 ${
            isInPreview ? "text-xs sm:text-sm mb-3" : "text-sm mb-1"
          }`}
        >
          <p>
            Tap the gift to discover an exclusive offer made for the players.
          </p>
        </div>

        {/* Shop Now Button */}
        <button
          className={`mb-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl active:scale-95 ${
            isInPreview ? "py-2 px-6 text-xs sm:text-sm" : "py-2  px-8 text-sm"
          }`}
        >
          Discover PS5
        </button>

        {/* Subtle glow effect */}
        <div className="absolute -inset-4 bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-3xl blur-3xl -z-10"></div>
      </div>
    </div>
  );
};

// Expanded PS5 Screen Component for Mockup
const ExpandedPS5InMockup = ({ onClose, isMobile = false }) => {
  return (
    <div
      className={`w-full h-full  relative overflow-hidden ${
        isMobile ? "text-xs" : ""
      }`}
    >
      {/* Close button */}
      <div
        className="absolute inset-0 "
        style={{
          backgroundImage: "url('/assets/ps.avif')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <button
        onClick={onClose}
        className={`absolute top-2 right-2 z-20 bg-gray-800 hover:bg-gray-700 text-white rounded-full transition-colors duration-200 ${
          isMobile ? "p-1" : "p-2"
        }`}
      >
        <X className={`${isMobile ? "w-3 h-3" : "w-4 h-4"}`} />
      </button>

      {/* PlayStation 5 brand badge */}
      <div
        className={`absolute top-2 left-2 z-10 ${isMobile ? "scale-75" : ""}`}
      >
        <div className="bg-blue-600 text-white px-2 py-1 rounded font-bold text-xs flex items-center space-x-1">
          <span>PS5 AD</span>
        </div>
        {/* <div className="mt-1">
          <div className="text-white font-bold text-lg">🎮</div>
        </div> */}
      </div>

      {/* Content */}
      <div
        className={`relative z-10 h-full flex items-center ${
          isMobile ? "flex-col justify-center px-4" : "justify-between px-6"
        }`}
      >
        {/*      
        <div className={`text-white space-y-2 ${isMobile ? 'text-center max-w-full' : 'max-w-xs'}`}>
          <div>
            <h1 className={`font-bold leading-tight text-blue-600 ${isMobile ? 'text-2xl mb-1' : 'text-3xl mb-2'}`}>
              PlayStation <span className="text-blue-600">5</span>
            </h1>
            <p className={`text-gray-700 leading-relaxed ${isMobile ? 'text-xs mb-3' : 'text-sm mb-4'}`}>
              Experience gaming like never before
            </p>
          </div>
          </div> */}
        {/* CTA Button matching your design */}
        {/* <div>
            <button className={`bg-blue-600 hover:bg-blue-700 text-white rounded-full font-bold transition-all duration-300 transform hover:scale-105 shadow-lg ${isMobile ? 'px-4 py-2 text-xs' : 'px-6 py-2 text-sm'}`}>
              Discover PS5
            </button>
          </div> */}

        {/* Right side - PS5 Console Image */}
        {/* {!isMobile && (
          <div className="flex justify-center">
            <div className="relative">
            
              <div className="w-32 h-40 bg-gradient-to-br from-white to-gray-300 rounded-2xl shadow-xl border-r-4 border-black transform rotate-2 relative overflow-hidden">
            
                <div className="absolute right-0 top-0 w-1/3 h-full bg-black rounded-l-2xl"></div>
                <div className="absolute left-2 top-3 w-2 h-2 bg-blue-500 rounded-full"></div>
                <div className="absolute left-2 top-6 w-3 h-0.5 bg-gray-400 rounded"></div>
                <div className="absolute left-2 top-7 w-2 h-0.5 bg-gray-400 rounded"></div>
                
                
                <div className="absolute bottom-3 left-2 text-black font-bold text-xs">
                  PS
                </div>
              </div>
              
             
              <div className="absolute -inset-4 bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-full blur-2xl"></div>
            </div>
          </div>
        )} */}
      </div>

      {/* Background texture/pattern similar to your image */}
      <div className="absolute inset-0 opacity-20">
        <div className="w-full h-full bg-gradient-to-br from-transparent via-gray-600 to-gray-800"></div>
      </div>
    </div>
  );
};

function GiftBoxAdMockup() {
  const [isMobile, setIsMobile] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
   <Helmet>
       <title>
  PS5 Campaign | Tap to Reveal Ad Showcase by Bidbox
        </title>
        <meta
          name="description"
          content="Discover how PS5 uses Tap to Reveal ads with Bidbox. Explore interactive gaming campaigns that excite players & boost brand engagement."
        />
        {/* <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/tap-to-reveal/ps"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
      <div className="min-h-screen bg-gray-50 mt-10">
        <div className="container mx-auto px-4 py-8 lg:py-12">
          <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
            {/* Left column - Content */}
            <div className="flex-1 lg:max-w-lg">
              {/* Header */}
              <header className="animate-slide-up">
                <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                      Tap to Reveal. Power Unleashed.
                    </h1>
                    <span className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                      Tap to Reveal
                    </span>
                  </div>
                </div>
              </header>

              {/* Content Section */}
              <div
                className="animate-slide-up"
                style={{ animationDelay: "0.2s" }}
              >
                {/* Make it yours section */}
                <div className="mb-8">
                  <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                    EXPERIENCE THE POWER OF PS5
                  </h2>
                  <p className="text-gray-900 leading-relaxed mb-6 max-w-md">
                    This interactive ad lets users tap to unlock the next-gen
                    thrill of PlayStation 5. With each tap, the gift box opens
                    to reveal powerful visuals and features—creating a sense of
                    excitement around the launch. Just plug in your images and
                    branding to deliver an immersive experience built for gamers
                    and fans alike.
                  </p>

                  {/* CTA Button */}
                  <Link to="/contact">
                    <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                      <span>Start with this Template</span>
                      <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                    </button>
                  </Link>
                </div>
              </div>
            </div>

            {/* Right column - Template Preview */}
            <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
              {/* Preview toggle */}
              <div
                className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4"
                style={{ animationDelay: "0.3s" }}
              >
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-blue-500/30">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-3">
                      <span
                        className={`text-sm font-medium transition-colors ${
                          isMobile ? "text-blue-400" : "text-gray-400"
                        }`}
                      >
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div
                          className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${
                            isMobile ? "left-1" : "left-7"
                          }`}
                        ></div>
                      </button>
                      <span
                        className={`text-sm font-medium transition-colors ${
                          !isMobile ? "text-blue-600" : "text-gray-600"
                        }`}
                      >
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="relative animate-fade-in"
                style={{ animationDelay: "0.4s" }}
              >
                {/* Mobile Mockup */}
                {isMobile && (
                  <div className="mx-auto max-w-xs">
                    {/* iPhone mockup with PS5 theme */}
                    <div className="relative rounded-[2.5rem] p-2 shadow-2xl bg-gradient-to-br from-gray-800 to-gray-900">
                      {/* Status bar area */}
                      <div className="bg-black rounded-[2rem] overflow-hidden border border-gray-700">
                        {/* Status bar */}
                        <div className="bg-black px-6 py-2 flex justify-between items-center text-white text-sm font-medium">
                          <span>9:41</span>
                          <div className="flex items-center space-x-1">
                            <div className="flex space-x-1">
                              <div className="w-1 h-1 bg-white rounded-full"></div>
                              <div className="w-1 h-1 bg-white rounded-full"></div>
                              <div className="w-1 h-1 bg-white rounded-full"></div>
                              <div className="w-1 h-1 bg-white rounded-full"></div>
                            </div>
                            <div className="w-6 h-3 border border-white rounded-sm relative">
                              <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                            </div>
                          </div>
                        </div>

                        {/* Browser bar */}
                        <div className="bg-gray-900 px-4 py-3 flex items-center space-x-3">
                          <div className="flex-1 bg-gray-800 rounded-lg px-3 py-2 text-sm text-gray-400 flex items-center justify-center border border-gray-700">
                            playstation.com
                          </div>
                        </div>

                        {/* Content area */}
                        <div className="p-2 bg-gray-900 h-[400px] overflow-y-auto hide-scrollbar">
                          <div className="space-y-2 mb-3">
                            <div className="h-2 bg-gray-700 rounded w-full"></div>
                            <div className="h-2 bg-gray-700 rounded w-3/4"></div>
                            <div className="h-2 bg-gray-700 rounded w-5/6"></div>
                          </div>

                          {/* PS5 Image Ad - Properly sized for mobile */}
                          <div className="mb-4">
                            <div className="h-80 rounded-lg overflow-hidden border border-blue-500/30">
                              {isExpanded ? (
                                <ExpandedPS5InMockup
                                  onClose={() => setIsExpanded(false)}
                                  isMobile={true}
                                />
                              ) : (
                                <PS5PromoUI
                                  isInPreview={true}
                                  onExpand={() => setIsExpanded(true)}
                                />
                              )}
                            </div>
                          </div>

                          {/* Additional content */}
                          <div className="space-y-2">
                            <div className="h-2 bg-gray-700 rounded w-full"></div>
                            <div className="h-2 bg-gray-700 rounded w-5/6"></div>
                            <div className="h-2 bg-gray-700 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-2 mt-2">
                            <div className="h-2 bg-gray-700 rounded w-full"></div>
                            <div className="h-2 bg-gray-700 rounded w-5/6"></div>
                            <div className="h-2 bg-gray-700 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-2 mt-2">
                            <div className="h-2 bg-gray-700 rounded w-full"></div>
                            <div className="h-2 bg-gray-700 rounded w-5/6"></div>
                            <div className="h-2 bg-gray-700 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-2 mt-2">
                            <div className="h-2 bg-gray-700 rounded w-full"></div>
                            <div className="h-2 bg-gray-700 rounded w-5/6"></div>
                            <div className="h-2 bg-gray-700 rounded w-4/6"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Desktop Mockup */}
                {!isMobile && (
                  <div className="w-full max-w-2xl mx-auto">
                    {/* Desktop Screen Frame */}
                    <div className="bg-gray-800 rounded-xl p-3 shadow-2xl">
                      {/* Screen */}
                      <div
                        className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700"
                        style={{ aspectRatio: "16/10" }}
                      >
                        {/* macOS-style window header */}
                        <div className="bg-gray-800 px-4 py-2 flex items-center border-b border-gray-700">
                          <div className="flex space-x-2">
                            <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                          </div>
                          <div className="flex-1 mx-6">
                            <div className="bg-gray-700 rounded-md px-3 py-1 text-sm text-gray-400 border border-gray-600 shadow-sm max-w-md">
                              🔒 playstation.com
                            </div>
                          </div>
                        </div>

                        {/* Browser content area */}
                        <div className="p-4 bg-gray-900 h-[500px] overflow-y-auto hide-scrollbar">
                          {/* Page header */}
                          <div className="mb-4">
                            <div className="h-4 bg-gray-700 rounded w-1/3 mb-2"></div>
                            <div className="h-3 bg-gray-700 rounded w-1/2"></div>
                          </div>

                          {/* PS5 Image Ad positioned in content */}
                          <div className="flex justify-center mb-6">
                            <div className="w-80 h-80 overflow-hidden rounded-lg border border-blue-500/30">
                              {isExpanded ? (
                                <ExpandedPS5InMockup
                                  onClose={() => setIsExpanded(false)}
                                  isMobile={false}
                                />
                              ) : (
                                <PS5PromoUI
                                  isInPreview={false}
                                  onExpand={() => setIsExpanded(true)}
                                />
                              )}
                            </div>
                          </div>

                          {/* Additional content placeholders */}
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-700 rounded w-full"></div>
                              <div className="h-3 bg-gray-700 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-700 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-700 rounded w-full"></div>
                              <div className="h-3 bg-gray-700 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-700 rounded w-4/6"></div>
                            </div>
                          </div>
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-700 rounded"></div>
                            <div className="h-24 bg-gray-700 rounded"></div>
                            <div className="h-24 bg-gray-700 rounded"></div>
                          </div>
                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-700 rounded"></div>
                            <div className="h-24 bg-gray-700 rounded"></div>
                            <div className="h-24 bg-gray-700 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-700 rounded w-full"></div>
                              <div className="h-3 bg-gray-700 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-700 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-700 rounded w-full"></div>
                              <div className="h-3 bg-gray-700 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-700 rounded w-4/6"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Monitor stand */}
                    <div className="flex justify-center">
                      <div className="w-20 h-4 bg-gray-700 rounded-b-lg"></div>
                    </div>
                    <div className="flex justify-center">
                      <div className="w-32 h-2 bg-gray-600 rounded-full"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Expanded PS5 Screen Overlay - Removed since we now show inline */}
        {/* {isExpanded && (
          <ExpandedPS5Screen onClose={() => setIsExpanded(false)} />
        )} */}

        <style jsx>{`
          @keyframes slide-up {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fade-in {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          .animate-slide-up {
            animation: slide-up 0.6s ease-out forwards;
          }

          .animate-fade-in {
            animation: fade-in 0.6s ease-out forwards;
          }

          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }

          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">
          Discover More Ads
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {/* Card 1 */}
          <Link
            to="/scratch-to-win/hm"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/sc.avif"
              alt="Card 1"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Scratch TO Win</h2>
            </div>
          </Link>

          {/* Card 2 */}
          <Link
            to="/swipe-to-reveal/pizza"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/sw.jpg"
              alt="Card 2"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Swipe to Reveal</h2>
            </div>
          </Link>

          {/* Card 3 */}
          <Link
            to="/tap-to-reveal/thumsup"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/tmmm.png"
              alt="Card 3"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Tap to Reveal</h2>
            </div>
          </Link>

          {/* Card 4 */}
          <Link
            to="/interactive-selector/travel-ramadan"
            className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl"
          >
            <img
              src="/assets/du.jpg"
              alt="Card 4"
              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <h2 className="text-lg font-semibold">Dubai Travel</h2>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}

export default GiftBoxAdMockup;

// import React, { useState, useRef, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Copy, Play, Pause, Maximize2, Download, Share2, Eye, Settings, Monitor, Smartphone, Hand } from 'lucide-react';

// // PlayStation Gift Box Ad Component
// const AnimatedGiftBox = ({ isInPreview = false }) => {
//   const [isOpened, setIsOpened] = useState(false);
//   const [showHand, setShowHand] = useState(false);
//   const [isOpening, setIsOpening] = useState(false);
//   const [showContent, setShowContent] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowHand(true);
//     }, 2000);
//     return () => clearTimeout(timer);
//   }, []);

//   const handleGiftClick = () => {
//     setIsOpening(true);
//     setTimeout(() => {
//       setShowContent(true);
//     }, 800);
//     setTimeout(() => {
//       setIsOpened(true);
//     }, 1500);
//   };

//   const closeAd = () => {
//     setIsOpened(false);
//     setIsOpening(false);
//     setShowContent(false);
//     setShowHand(false);
//   };

//   return (
//     <div className="w-full h-full bg-gradient-to-br from-blue-900 via-blue-700 to-black flex items-center justify-center relative overflow-hidden">
//       {/* Floating particles background */}
//       <div className="absolute inset-0">
//         {[...Array(isInPreview ? 15 : 30)].map((_, i) => (
//           <div
//             key={i}
//             className="absolute w-1 h-1 bg-white rounded-full opacity-30 animate-pulse"
//             style={{
//               left: `${Math.random() * 100}%`,
//               top: `${Math.random() * 100}%`,
//               animationDelay: `${Math.random() * 3}s`,
//               animationDuration: `${2 + Math.random() * 2}s`
//             }}
//           />
//         ))}
//       </div>

//       {!isOpened ? (
//         <div className="relative">
//           {/* Gift Box Container */}
//           <div
//             className={`relative cursor-pointer transform transition-all duration-1000 ${
//               showHand ? 'hover:scale-110 hover:rotate-2' : 'animate-bounce'
//             } ${isOpening ? 'animate-pulse scale-125' : ''}`}
//             onClick={handleGiftClick}
//           >
//             {/* Gift Box Shadow */}
//             <div className="absolute top-6 left-2 w-20 h-6 bg-black opacity-20 rounded-full blur-md transform scale-x-150" />

//             {/* PlayStation Gift Box Base */}
//             <div className="relative">
//               {/* Box Body */}
//               <div className={`w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg shadow-2xl border-2 border-blue-700 transform transition-all duration-1000 ${
//                 isOpening ? 'rotate-y-45 scale-110' : 'rotate-y-12'
//               }`}>

//                 {/* Box Lid */}
//                 <div className={`absolute -top-2 -left-1 w-22 h-5 bg-gradient-to-br from-blue-400 to-blue-500 rounded-lg shadow-lg border border-blue-600 transform transition-all duration-1000 ${
//                   isOpening ? 'rotate-45 translate-y-4 translate-x-6 scale-110' : ''
//                 }`}>
//                   <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-2 h-full bg-gradient-to-b from-white to-gray-200 shadow-inner" />
//                 </div>

//                 {/* Vertical Ribbon */}
//                 <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-2 h-full bg-gradient-to-b from-white to-gray-200 shadow-inner" />

//                 {/* Horizontal Ribbon */}
//                 <div className="absolute top-1/2 left-0 transform -translate-y-1/2 w-full h-2 bg-gradient-to-r from-white to-gray-200 shadow-inner" />

//                 {/* PlayStation Logo on Box */}
//                 <div className="absolute top-1 left-1 text-white font-bold text-xs">PS5</div>

//                 {/* Bow */}
//                 <div className={`absolute -top-3 left-1/2 transform -translate-x-1/2 transition-all duration-700 ${
//                   isOpening ? 'scale-150 rotate-180' : ''
//                 }`}>
//                   <div className="relative">
//                     <div className="w-4 h-3 bg-gradient-to-br from-white to-gray-200 rounded-full shadow-lg" />
//                     <div className="absolute -left-2 top-0 w-4 h-3 bg-gradient-to-bl from-white to-gray-200 rounded-full shadow-lg" />
//                     <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1 h-2 bg-gray-300 rounded shadow-inner" />
//                   </div>
//                 </div>

//                 {/* Content Preview - PlayStation 5 emerging */}
//                 {showContent && (
//                   <div className="absolute top-2 left-1/2 transform -translate-x-1/2 animate-bounce">
//                     <div className="w-10 h-12 bg-white rounded-lg shadow-xl transform rotate-12 animate-pulse">
//                       <div className="absolute inset-0.5 bg-gradient-to-br from-gray-100 to-gray-300 rounded-md flex items-center justify-center">
//                         <div className="text-xs font-bold text-gray-600">PS5</div>
//                       </div>
//                       <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-blue-500 rounded-full animate-ping" />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Animated Hand Cursor */}
//           {showHand && !isOpening && (
//             <div className="absolute -right-10 -top-6 animate-bounce">
//               <Hand
//                 size={24}
//                 className="text-white drop-shadow-lg transform rotate-12 animate-pulse"
//               />
//               <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-2 py-1 rounded-full text-xs whitespace-nowrap">
//                 Click!
//               </div>
//             </div>
//           )}

//           {/* Enhanced Sparkle effects */}
//           <div className="absolute -inset-8 pointer-events-none">
//             {[...Array(8)].map((_, i) => (
//               <div
//                 key={i}
//                 className={`absolute w-1 h-1 bg-yellow-300 rounded-full ${
//                   isOpening ? 'animate-ping' : 'animate-pulse'
//                 }`}
//                 style={{
//                   left: `${20 + Math.random() * 60}%`,
//                   top: `${20 + Math.random() * 60}%`,
//                   animationDelay: `${i * 0.3}s`,
//                   animationDuration: isOpening ? '0.5s' : '2s'
//                 }}
//               />
//             ))}
//           </div>

//           {/* Opening burst effect */}
//           {isOpening && (
//             <div className="absolute inset-0 pointer-events-none">
//               {[...Array(12)].map((_, i) => (
//                 <div
//                   key={i}
//                   className="absolute w-0.5 h-0.5 bg-white rounded-full animate-ping"
//                   style={{
//                     left: '50%',
//                     top: '50%',
//                     transform: `translate(-50%, -50%) rotate(${i * 30}deg) translateY(-${30 + Math.random() * 30}px)`,
//                     animationDelay: `${i * 0.1}s`,
//                     animationDuration: '1s'
//                   }}
//                 />
//               ))}
//             </div>
//           )}
//         </div>
//       ) : (
//         /* Compact Ad for Preview */
//         <div className="w-full h-full bg-black bg-opacity-95 flex items-center justify-center relative">
//           <button
//             onClick={closeAd}
//             className="absolute top-2 right-2 w-6 h-6 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full flex items-center justify-center text-white text-sm font-bold transition-all duration-300 hover:scale-110"
//           >
//             ×
//           </button>

//           <div className="relative p-2 text-center">
//             <div className="flex items-center justify-center mb-2">
//               <div className="text-lg font-bold text-white mr-2">PlayStation</div>
//               <div className="text-2xl font-bold text-blue-400">5</div>
//             </div>

//             <div className="w-16 h-16 mx-auto mb-2 rounded-lg shadow-xl overflow-hidden">
//               {/* <div className="w-full h-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center">
//                 <div className="text-white font-bold text-xs">PS5</div>
//               </div> */}
//               <div className="w-16 h-16 mx-auto mb-2 rounded-lg shadow-xl overflow-hidden">
//   <img
//     src="/assets/ps.avif" // <-- Replace this with your actual image path
//     alt="PS5"
//     className="w-full h-full object-cover"
//   />
// </div>
//             </div>

//             <div className="text-white text-xs mb-2 font-bold">
//               🎮 EXCLUSIVE DEAL! 🎮
//             </div>
//             <div className="text-white text-xs mb-2">
//               PlayStation 5 Games
//             </div>
//             <button className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold py-1 px-3 rounded-full text-xs hover:scale-105 transition-transform">
//               Shop Now!
//             </button>
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes twinkle {
//           0%, 100% { opacity: 0; transform: scale(0); }
//           50% { opacity: 1; transform: scale(1); }
//         }
//         .animate-twinkle {
//           animation: twinkle 2s infinite;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default function GiftBoxAdMockup() {
//     const [selectedDevice, setSelectedDevice] = useState('Mobile');
//     const [isPlaying, setIsPlaying] = useState(false);

//     return (
//         <div className="mt-14 min-h-screen bg-gradient-to-br from-slate-50 via-purple-50 to-indigo-50 p-6">
//             {/* Header */}
//             <div className="mb-8">
//                 <div className="flex items-center justify-between">
//                     <div>
//                         <h1 className="text-3xl font-bold text-gray-900 mb-2">PlayStation Gift Box Campaign</h1>
//                         <p className="text-gray-600">Interactive ad preview with animated gift box reveal</p>
//                     </div>
//                     <div className="flex items-center gap-3">
//                         <button className="px-4 py-2 bg-white rounded-lg shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors flex items-center gap-2">
//                             <Settings className="h-4 w-4" />
//                             Settings
//                         </button>
//                         <button className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors flex items-center gap-2">
//                             <Share2 className="h-4 w-4" />
//                             Share
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//                 {/* Left Sidebar - Project Info */}
//                 <div className="lg:col-span-1">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <div className="flex items-center gap-3 mb-4">
//                             <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-blue-600 rounded-xl flex items-center justify-center">
//                                 <Eye className="h-6 w-6 text-white" />
//                             </div>
//                             <div>
//                                 <h2 className="text-lg font-semibold text-gray-900">PlayStation Gift</h2>
//                                 <p className="text-sm text-gray-500">ID: 789456</p>
//                             </div>
//                         </div>

//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Status</span>
//                                 <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">Live</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Campaign</span>
//                                 <span className="text-sm text-gray-900">Holiday 2024</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Updated</span>
//                                 <span className="text-sm text-gray-900">1 hour ago</span>
//                             </div>
//                         </div>

//                         <button className="w-full mt-4 text-indigo-600 hover:text-indigo-700 text-sm font-medium">
//                             View Campaign Analytics
//                         </button>
//                     </div>

//                     {/* Quick Actions */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
//                         <div className="space-y-3">
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors flex items-center gap-2">
//                                 <Download className="h-4 w-4" />
//                                 Export Creative
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors flex items-center gap-2">
//                                 <Copy className="h-4 w-4" />
//                                 Copy Ad Tag
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors flex items-center gap-2">
//                                 <Maximize2 className="h-4 w-4" />
//                                 Fullscreen Test
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Center Content - Preview Area */}
//                 <div className="lg:col-span-2">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         {/* Device Toggle */}
//                         <div className="flex items-center justify-between mb-6">
//                             <div className="flex items-center gap-2">
//                                 <h3 className="text-lg font-semibold text-gray-900">Interactive Preview</h3>
//                                 <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600 transition-colors" />
//                             </div>
//                             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//                                 {[
//                                     { name: 'Mobile', icon: Smartphone },
//                                     { name: 'Desktop', icon: Monitor }
//                                 ].map(({ name, icon: Icon }) => (
//                                     <button
//                                         key={name}
//                                         className={`px-3 py-2 rounded-md text-sm font-medium transition-all flex items-center gap-2 ${
//                                             selectedDevice === name
//                                                 ? 'bg-white text-indigo-600 shadow-sm'
//                                                 : 'text-gray-600 hover:text-gray-900'
//                                         }`}
//                                         onClick={() => setSelectedDevice(name)}
//                                     >
//                                         <Icon className="h-4 w-4" />
//                                         {name}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Navigation */}
//                         <div className="flex items-center justify-between mb-6">
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors">
//                                 <ChevronLeft className="h-4 w-4" />
//                                 Previous Ad
//                             </button>
//                             <div className="flex items-center gap-2">
//                                 <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                             </div>
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors">
//                                 Next Ad
//                                 <ChevronRight className="h-4 w-4" />
//                             </button>
//                         </div>

//                         {/* Preview Container */}
//                         <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-8 min-h-[600px] flex items-center justify-center">
//                             {/* Device Frame */}
//                             <div className="relative">
//                                 {selectedDevice === 'Mobile' ? (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-purple-500/20 to-blue-500/20 rounded-3xl blur-xl"></div>
//                                         <div className="relative bg-gray-900 rounded-3xl p-2 shadow-2xl">
//                                             <div className="bg-black rounded-2xl overflow-hidden">
//                                                 <div className="w-[280px] h-[560px] relative">
//                                                     <AnimatedGiftBox isInPreview={true} />
//                                                 </div>
//                                             </div>
//                                             <div className="w-20 h-1 bg-gray-600 rounded-full mx-auto mt-2"></div>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-purple-500/20 to-blue-500/20 rounded-xl blur-xl"></div>
//                                         <div className="relative bg-white rounded-xl shadow-2xl p-4">
//                                             <div className="bg-gray-100 rounded-lg p-2">
//                                                 <div className="w-[320px] h-[600px] bg-black rounded overflow-hidden relative">
//                                                     <AnimatedGiftBox isInPreview={true} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Interaction Guide */}
//                         <div className="mt-6 bg-purple-50 rounded-lg p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center">
//                                     <Hand className="h-4 w-4" />
//                                 </div>
//                                 <div>
//                                     <h4 className="font-semibold text-purple-900">Interactive Elements</h4>
//                                     <p className="text-sm text-purple-700">Click the gift box to reveal the PlayStation 5 promotion</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Right Sidebar - Details */}
//                 <div className="lg:col-span-1">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Creative Details</h3>

//                         <div className="space-y-4">
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">Dimensions</div>
//                                 <div className="text-lg font-semibold text-gray-900">320 × 600px</div>
//                             </div>

//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">Format</div>
//                                 <div className="text-lg font-semibold text-gray-900">Interactive HTML5</div>
//                             </div>

//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">Animation</div>
//                                 <div className="text-lg font-semibold text-gray-900">React + CSS</div>
//                             </div>

//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">File Size</div>
//                                 <div className="text-lg font-semibold text-gray-900">1.8 MB</div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Performance Metrics */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Engagement Stats</h3>
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Interaction Rate</span>
//                                 <span className="text-sm font-semibold text-green-600">4.2%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Click Through</span>
//                                 <span className="text-sm font-semibold text-blue-600">3.8%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Completion Rate</span>
//                                 <span className="text-sm font-semibold text-purple-600">89%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Animation Timeline */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Animation Flow</h3>
//                         <div className="space-y-3">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Gift box bounces (0-2s)</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Hand cursor appears (2s)</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-green-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Box opens on click</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">PS5 ad reveals</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }
